module.exports = __webpack_public_path__ + "e135c30be8d4d2989a3654e70e7f126d.png";